var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _path0, _g6, _path1, _g7, _path10, _g8, _path11, _g9, _path12, _path13, _g0, _path14, _path15, _g1, _path16, _path17, _g10, _path18, _path19, _g11, _path20, _g12, _path21, _g13, _g14, _path22, _path23, _g15, _path24, _path25, _g16, _path26, _g17, _path27, _g18, _g19, _path28, _path29, _g20, _path30, _path31, _g21, _path32, _g22, _path33, _g23, _path34, _g24, _g25, _path35, _g26, _g27, _path36, _g28, _path37, _path38, _g29, _path39, _path40, _g30, _path41, _g31, _path42, _path43, _g32, _path44, _path45, _g33, _path46, _g34, _path47, _path48, _g35, _path49, _g36, _path50, _g37, _g38, _path51, _path52, _g39, _path53, _g40, _path54, _g41, _g42, _path55, _path56, _g43, _path57, _g44, _path58, _path59, _g45, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g46, _path74, _g47, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.005 315C216.91 315 259.799 309.207 259.799 302.062C259.799 294.916 216.91 289.123 164.005 289.123C111.099 289.123 68.2109 294.916 68.2109 302.062C68.2109 309.207 111.099 315 164.005 315Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 164.983C66.2812 164.983 100.239 194.124 140.508 183.691L135.54 164.458C104.973 172.326 79.3148 149.946 79.3148 149.946L66.2812 164.983Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 149,
    width: 75,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 164.983C66.2812 164.983 100.239 194.124 140.508 183.691L135.54 164.458C104.973 172.326 79.3148 149.946 79.3148 149.946L66.2812 164.983Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5469 168.364C61.5469 168.364 90.9455 197.912 135.482 187.771L132.676 177.514C99.8294 185.732 70.3723 162.419 70.3723 162.419L61.5469 168.364Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 149,
    width: 75,
    height: 37
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 164.983C66.2812 164.983 100.239 194.124 140.508 183.691L135.54 164.458C104.973 172.326 79.3148 149.946 79.3148 149.946L66.2812 164.983Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5974 161.253C98.4285 163.759 99.4805 166.732 101.994 167.956C104.507 169.121 107.488 168.072 108.715 165.566C109.884 163.06 108.832 160.088 106.319 158.864C103.747 157.698 100.766 158.747 99.5974 161.253Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 149,
    width: 75,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 164.983C66.2812 164.983 100.239 194.124 140.508 183.691L135.54 164.458C104.973 172.326 79.3148 149.946 79.3148 149.946L66.2812 164.983Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9261 165.158C83.991 167.139 84.7508 169.529 86.6795 170.403C88.6083 171.277 90.8877 170.403 91.8813 168.363C92.8164 166.382 92.0566 163.992 90.1279 163.118C88.1991 162.244 85.8613 163.118 84.9261 165.158Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 149,
    width: 75,
    height: 37
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 164.983C66.2812 164.983 100.239 194.124 140.508 183.691L135.54 164.458C104.973 172.326 79.3148 149.946 79.3148 149.946L66.2812 164.983Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.05 172.851C110.349 174.366 110.992 176.114 112.453 176.814C113.914 177.513 115.726 176.872 116.427 175.415C117.129 173.9 116.486 172.151 115.025 171.452C113.563 170.694 111.752 171.335 111.05 172.851Z",
    fill: "#673620"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0409 165.391C51.2603 160.029 47.8704 139.747 61.3715 138.057C66.0473 137.474 72.5933 142.603 75.1649 146.799C74.7558 144.993 74.7558 140.389 77.6781 141.379C78.8471 141.787 80.8927 146.042 81.0096 151.404C78.4379 157.465 72.1842 164.459 67.0409 165.391Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 138,
    width: 30,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0409 165.391C51.2603 160.029 47.8704 139.747 61.3715 138.057C66.0473 137.474 72.5933 142.603 75.1649 146.799C74.7558 144.993 74.7558 140.389 77.6781 141.379C78.8471 141.787 80.8927 146.042 81.0096 151.404C78.4379 157.465 72.1842 164.459 67.0409 165.391Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9054 165.682C75.574 165.274 63.3002 160.262 61.4299 157.232C56.345 152.569 53.4812 144.992 62.1312 136.833C49.799 137.591 46 148.314 46 148.314L66.1641 171.802L78.9054 165.682Z",
    fill: "#301007"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 164.983C253.719 164.983 219.762 194.124 179.492 183.691L184.46 164.458C214.969 172.326 240.686 149.946 240.686 149.946L253.719 164.983Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 149,
    width: 75,
    height: 37
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 164.983C253.719 164.983 219.762 194.124 179.492 183.691L184.46 164.458C214.969 172.326 240.686 149.946 240.686 149.946L253.719 164.983Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.454 168.364C258.454 168.364 229.056 197.912 184.52 187.771L187.325 177.514C220.172 185.732 249.629 162.419 249.629 162.419L258.454 168.364Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 149,
    width: 75,
    height: 37
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 164.983C253.719 164.983 219.762 194.124 179.492 183.691L184.46 164.458C214.969 172.326 240.686 149.946 240.686 149.946L253.719 164.983Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.406 161.253C221.575 163.759 220.523 166.732 218.01 167.956C215.497 169.121 212.516 168.072 211.289 165.566C210.12 163.06 211.172 160.088 213.685 158.864C216.198 157.698 219.179 158.747 220.406 161.253Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 149,
    width: 75,
    height: 37
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 164.983C253.719 164.983 219.762 194.124 179.492 183.691L184.46 164.458C214.969 172.326 240.686 149.946 240.686 149.946L253.719 164.983Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.018 165.158C235.953 167.139 235.193 169.529 233.265 170.403C231.336 171.277 229.056 170.403 228.063 168.363C227.128 166.382 227.887 163.992 229.816 163.118C231.803 162.244 234.083 163.118 235.018 165.158Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 149,
    width: 75,
    height: 37
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 164.983C253.719 164.983 219.762 194.124 179.492 183.691L184.46 164.458C214.969 172.326 240.686 149.946 240.686 149.946L253.719 164.983Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.892 172.851C209.593 174.366 208.951 176.114 207.489 176.814C206.028 177.513 204.216 176.872 203.515 175.415C202.814 173.9 203.457 172.151 204.918 171.452C206.437 170.694 208.191 171.335 208.892 172.851Z",
    fill: "#673620"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.902 165.391C268.683 160.029 272.073 139.747 258.572 138.057C253.896 137.474 247.35 142.603 244.778 146.799C245.187 144.993 245.187 140.389 242.265 141.379C241.096 141.787 239.05 146.042 238.934 151.404C241.564 157.465 247.817 164.459 252.902 165.391Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 138,
    width: 29,
    height: 28
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.902 165.391C268.683 160.029 272.073 139.747 258.572 138.057C253.896 137.474 247.35 142.603 244.778 146.799C245.187 144.993 245.187 140.389 242.265 141.379C241.096 141.787 239.05 146.042 238.934 151.404C241.564 157.465 247.817 164.459 252.902 165.391Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.098 165.682C244.429 165.274 256.703 160.262 258.573 157.232C263.658 152.569 266.522 144.992 257.872 136.833C270.204 137.649 274.003 148.373 274.003 148.373L253.839 171.86L241.098 165.682Z",
    fill: "#301007"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.834 251.414C221.516 252.23 214.151 250.132 207.372 245.062C202.228 241.157 197.436 235.503 194.104 227.927L187.441 231.249C191.65 239.991 197.494 246.344 203.69 250.657C212.223 256.543 221.34 258.466 227.77 257.242L226.834 251.414Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 227,
    width: 41,
    height: 31
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.834 251.414C221.516 252.23 214.151 250.132 207.372 245.062C202.228 241.157 197.436 235.503 194.104 227.927L187.441 231.249C191.65 239.991 197.494 246.344 203.69 250.657C212.223 256.543 221.34 258.466 227.77 257.242L226.834 251.414Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.832 235.153C192.41 237.834 194.981 240.282 197.144 242.439C203.164 248.383 210.119 252.696 218.126 254.678C220.289 255.202 222.51 255.843 224.789 255.902C224.964 255.902 225.432 256.484 225.549 256.601C226.25 257.184 226.952 257.65 227.711 258.058C229.932 259.282 232.329 259.865 234.842 259.748C240.219 259.573 244.661 256.484 248.168 252.405C249.337 251.064 250.447 249.665 251.558 248.208C251.967 247.626 252.434 246.985 252.843 246.402C252.902 246.343 253.194 245.877 253.311 245.994C253.545 246.285 253.019 247.276 252.902 247.567C252.259 249.257 251.499 250.831 250.622 252.405C246.999 258.816 241.271 263.653 233.965 264.294C230.692 264.586 227.361 264.061 224.38 262.721C222.802 262.021 221.399 260.739 219.821 260.156C217.016 259.107 213.977 258.991 211.171 257.883C202.346 254.328 193.988 247.509 189.137 239L190.832 235.153Z",
    fill: "#CE8710"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.183 260.623C222.682 259.574 217.714 253.163 223.442 249.142C230.982 243.78 238.346 247.976 241.911 245.412C241.561 247.335 239.456 249.55 234.722 251.182C234.255 251.357 236.651 251.124 237.06 251.065C239.515 250.657 241.502 249.258 243.197 247.568C247.054 243.78 248.633 244.421 248.574 244.479C245.243 248.676 243.898 252.872 242.554 254.446C237.294 260.682 232.443 261.906 227.183 260.623Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 244,
    width: 29,
    height: 18
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.183 260.623C222.682 259.574 217.714 253.163 223.442 249.142C230.982 243.78 238.346 247.976 241.911 245.412C241.561 247.335 239.456 249.55 234.722 251.182C234.255 251.357 236.651 251.124 237.06 251.065C239.515 250.657 241.502 249.258 243.197 247.568C247.054 243.78 248.633 244.421 248.574 244.479C245.243 248.676 243.898 252.872 242.554 254.446C237.294 260.682 232.443 261.906 227.183 260.623Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.374 235.388C198.368 237.602 200.18 239.759 201.699 241.624C205.907 246.811 211.109 250.774 217.363 253.164C219.058 253.805 220.811 254.504 222.565 254.737C222.682 254.737 223.032 255.262 223.091 255.32C223.558 255.845 224.143 256.253 224.669 256.66C226.305 257.826 228.234 258.526 230.221 258.7C234.546 259.108 238.462 257.185 241.677 254.388C242.729 253.455 243.781 252.523 244.774 251.532C245.183 251.124 245.593 250.657 246.002 250.25C246.06 250.191 246.352 249.9 246.411 249.958C246.528 250.191 246.002 250.949 245.943 251.124C245.3 252.348 244.482 253.513 243.605 254.621C240.099 259.167 234.955 262.314 229.052 262.081C226.422 261.964 223.792 261.265 221.513 259.924C220.285 259.225 219.35 258.118 218.064 257.476C215.902 256.369 213.505 256.019 211.343 254.854C204.622 251.24 198.543 245.179 195.504 238.069L197.374 235.388Z",
    fill: "#301007"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.132 302.236C153.132 302.236 152.489 265.868 158.918 247.335L120.519 234.163C112.57 257.301 112.512 302.586 112.512 302.586L153.132 302.236Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 234,
    width: 47,
    height: 69
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.132 302.236C153.132 302.236 152.489 265.868 158.918 247.335L120.519 234.163C112.57 257.301 112.512 302.586 112.512 302.586L153.132 302.236Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.421 302.527C117.655 290.521 118.883 257.301 125.37 238.592L158.159 249.841C158.392 248.967 158.685 248.151 158.977 247.335L120.577 234.163C112.629 257.301 112.57 302.586 112.57 302.586L117.421 302.527Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 234,
    width: 47,
    height: 69
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.132 302.236C153.132 302.236 152.489 265.868 158.918 247.335L120.519 234.163C112.57 257.301 112.512 302.586 112.512 302.586L153.132 302.236Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.701 277.292C136.065 277.059 134.545 278.166 134.311 279.798C134.077 281.43 135.188 282.945 136.824 283.178C138.461 283.411 139.98 282.304 140.214 280.672C140.448 279.04 139.338 277.525 137.701 277.292ZM123.557 261.206C119.758 261.206 116.719 264.237 116.719 268.025C116.719 271.755 119.758 274.844 123.557 274.844C127.356 274.844 130.395 271.813 130.395 268.025C130.395 264.237 127.298 261.206 123.557 261.206Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 261,
    width: 25,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 261,
    width: 25,
    height: 23
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.701 277.292C136.065 277.059 134.545 278.166 134.311 279.798C134.077 281.43 135.188 282.945 136.824 283.178C138.461 283.411 139.98 282.304 140.214 280.672C140.448 279.04 139.338 277.525 137.701 277.292ZM123.557 261.206C119.758 261.206 116.719 264.237 116.719 268.025C116.719 271.755 119.758 274.844 123.557 274.844C127.356 274.844 130.395 271.813 130.395 268.025C130.395 264.237 127.298 261.206 123.557 261.206Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.132 302.236C153.132 302.236 152.489 265.868 158.918 247.335L120.519 234.163C112.57 257.301 112.512 302.586 112.512 302.586L153.132 302.236Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.421 302.527C117.655 290.521 118.883 257.301 125.37 238.592L158.159 249.841C158.392 248.967 158.685 248.151 158.977 247.335L120.577 234.163C112.629 257.301 112.57 302.586 112.57 302.586L117.421 302.527Z",
    fill: "#C3A088"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.154 303.344C112.394 303.344 111.692 302.936 111.283 302.295C110.874 301.654 110.874 300.838 111.225 300.138C114.849 293.786 124.551 289.123 134.428 289.123C144.598 289.123 151.904 294.019 154.592 300.663C154.826 301.246 154.768 301.945 154.417 302.47C154.066 302.994 153.482 303.285 152.839 303.285C144.949 303.344 121.628 303.344 113.154 303.344Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 289,
    width: 45,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.154 303.344C112.394 303.344 111.692 302.936 111.283 302.295C110.874 301.654 110.874 300.838 111.225 300.138C114.849 293.786 124.551 289.123 134.428 289.123C144.598 289.123 151.904 294.019 154.592 300.663C154.826 301.246 154.768 301.945 154.417 302.47C154.066 302.994 153.482 303.285 152.839 303.285C144.949 303.344 121.628 303.344 113.154 303.344Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.645 298.156C110.171 298.972 111.106 299.497 112.158 299.497C122.094 299.497 145.298 299.497 154.357 299.438C155.175 299.438 155.935 299.089 156.402 298.448C156.695 298.856 156.928 299.264 157.162 299.672C157.571 300.429 157.571 301.362 157.104 302.119C156.636 302.877 155.818 303.343 154.883 303.343C145.59 303.402 121.627 303.402 111.457 303.402C110.347 303.402 109.294 302.76 108.827 301.828C108.301 300.837 108.418 299.73 109.119 298.856C109.236 298.564 109.411 298.389 109.645 298.156Z",
    fill: "#301007"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.876 302.236C174.876 302.236 175.519 265.868 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527L174.876 302.236Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 234,
    width: 47,
    height: 69
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174.876 302.236C174.876 302.236 175.519 265.868 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527L174.876 302.236Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.645 302.527C210.412 290.521 209.184 257.301 202.697 238.592L169.908 249.841C169.674 248.967 169.382 248.151 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527H210.645Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 234,
    width: 47,
    height: 69
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.876 302.236C174.876 302.236 175.519 265.868 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527L174.876 302.236Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.02 277.292C190.656 277.059 192.176 278.166 192.409 279.798C192.643 281.43 191.533 282.945 189.896 283.178C188.26 283.411 186.74 282.304 186.506 280.672C186.273 279.04 187.442 277.525 189.02 277.292ZM203.164 261.206C206.963 261.206 210.002 264.237 210.002 268.025C210.002 271.755 206.963 274.844 203.164 274.844C199.365 274.844 196.325 271.813 196.325 268.025C196.325 264.237 199.423 261.206 203.164 261.206Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 261,
    width: 24,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 261,
    width: 24,
    height: 23
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M189.02 277.292C190.656 277.059 192.176 278.166 192.409 279.798C192.643 281.43 191.533 282.945 189.896 283.178C188.26 283.411 186.74 282.304 186.506 280.672C186.273 279.04 187.442 277.525 189.02 277.292ZM203.164 261.206C206.963 261.206 210.002 264.237 210.002 268.025C210.002 271.755 206.963 274.844 203.164 274.844C199.365 274.844 196.325 271.813 196.325 268.025C196.325 264.237 199.423 261.206 203.164 261.206Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.876 302.236C174.876 302.236 175.519 265.868 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527L174.876 302.236Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.645 302.527C210.412 290.521 209.184 257.301 202.697 238.592L169.908 249.841C169.674 248.967 169.382 248.151 169.09 247.335L207.489 234.163C215.496 257.301 215.496 302.527 215.496 302.527H210.645Z",
    fill: "#301007"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M214.911 303.344C215.671 303.344 216.372 302.936 216.781 302.295C217.19 301.654 217.19 300.838 216.84 300.138C213.216 293.786 203.514 289.123 193.636 289.123C183.467 289.123 176.161 294.019 173.472 300.663C173.239 301.246 173.297 301.945 173.648 302.47C173.998 302.994 174.583 303.285 175.226 303.285C183.058 303.344 206.378 303.344 214.911 303.344Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 289,
    width: 45,
    height: 15
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M214.911 303.344C215.671 303.344 216.372 302.936 216.781 302.295C217.19 301.654 217.19 300.838 216.84 300.138C213.216 293.786 203.514 289.123 193.636 289.123C183.467 289.123 176.161 294.019 173.472 300.663C173.239 301.246 173.297 301.945 173.648 302.47C173.998 302.994 174.583 303.285 175.226 303.285C183.058 303.344 206.378 303.344 214.911 303.344Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.36 298.156C217.834 298.972 216.899 299.497 215.847 299.497C205.911 299.497 182.708 299.497 173.648 299.438C172.83 299.438 172.07 299.089 171.603 298.448C171.31 298.856 171.077 299.264 170.843 299.672C170.434 300.429 170.434 301.362 170.901 302.119C171.369 302.877 172.187 303.343 173.122 303.343C182.415 303.402 206.378 303.402 216.548 303.402C217.659 303.402 218.711 302.76 219.178 301.828C219.704 300.837 219.529 299.73 218.886 298.856C218.769 298.564 218.594 298.389 218.36 298.156Z",
    fill: "#301007"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M196.498 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 253.921 138.636 269.541 163.885 269.541C189.134 269.541 209.707 253.979 209.707 223.964C209.766 207.004 203.921 182.002 196.498 156.766Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 156,
    width: 92,
    height: 114
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M196.498 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 253.921 138.636 269.541 163.885 269.541C189.134 269.541 209.707 253.979 209.707 223.964C209.766 207.004 203.921 182.002 196.498 156.766Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.117 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 237.253 122.271 249.433 128.992 258.875C125.193 250.366 123.031 240.575 123.031 230.142C123.089 213.241 128.583 183.051 137.117 156.766Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 156,
    width: 92,
    height: 114
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.498 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 253.921 138.636 269.541 163.885 269.541C189.134 269.541 209.707 253.979 209.707 223.964C209.766 207.004 203.921 182.002 196.498 156.766Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.887 156.766H196.498C203.979 181.943 209.765 206.946 209.765 223.964C209.765 237.253 205.732 249.433 199.011 258.875C202.81 250.366 204.972 240.575 204.972 230.142C204.972 213.241 199.478 183.051 190.887 156.766Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 156,
    width: 92,
    height: 114
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M196.498 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 253.921 138.636 269.541 163.885 269.541C189.134 269.541 209.707 253.979 209.707 223.964C209.766 207.004 203.921 182.002 196.498 156.766Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.647 237.661C134.075 237.661 131.971 239.817 131.971 242.498C131.971 245.179 134.075 247.335 136.647 247.335C139.219 247.335 141.323 245.179 141.323 242.498C141.381 239.817 139.277 237.661 136.647 237.661ZM192.288 237.952C194.801 237.952 196.789 239.817 196.789 242.148C196.789 244.479 194.743 246.345 192.288 246.345C189.775 246.345 187.788 244.479 187.788 242.148C187.788 239.875 189.775 237.952 192.288 237.952ZM204.036 221.109C206.841 221.109 209.062 223.323 209.062 226.121C209.062 228.86 206.783 231.133 204.036 231.133C201.23 231.133 199.009 228.918 199.009 226.121C199.009 223.323 201.23 221.109 204.036 221.109ZM122.503 219.652C119.698 219.652 117.477 221.866 117.477 224.664C117.477 227.403 119.756 229.676 122.503 229.676C125.308 229.676 127.529 227.461 127.529 224.664C127.529 221.866 125.308 219.652 122.503 219.652ZM193.691 210.676C195.327 210.676 196.672 212.017 196.672 213.649C196.672 215.28 195.327 216.621 193.691 216.621C192.054 216.621 190.71 215.28 190.71 213.649C190.71 212.017 192.054 210.676 193.691 210.676ZM133.14 208.287C131.504 208.287 130.159 209.627 130.159 211.259C130.159 212.891 131.504 214.231 133.14 214.231C134.777 214.231 136.121 212.891 136.121 211.259C136.121 209.569 134.835 208.287 133.14 208.287ZM202.516 187.13C206.315 187.13 209.355 190.161 209.355 193.949C209.355 197.679 206.315 200.768 202.516 200.768C198.717 200.768 195.678 197.738 195.678 193.949C195.678 190.161 198.717 187.13 202.516 187.13ZM125.075 187.13C121.276 187.13 118.236 190.161 118.236 193.949C118.236 197.679 121.276 200.768 125.075 200.768C128.874 200.768 131.913 197.738 131.913 193.949C131.913 190.161 128.815 187.13 125.075 187.13ZM190.126 177.922C191.762 177.922 193.106 179.262 193.106 180.894C193.106 182.526 191.762 183.867 190.126 183.867C188.489 183.867 187.145 182.526 187.145 180.894C187.145 179.262 188.489 177.922 190.126 177.922ZM137.407 177.922C135.77 177.922 134.426 179.262 134.426 180.894C134.426 182.526 135.77 183.867 137.407 183.867C139.043 183.867 140.388 182.526 140.388 180.894C140.388 179.262 139.043 177.922 137.407 177.922Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 177,
    width: 92,
    height: 71
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 177,
    width: 93,
    height: 71
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.651 237.661C134.079 237.661 131.975 239.817 131.975 242.498C131.975 245.179 134.079 247.335 136.651 247.335C139.223 247.335 141.327 245.179 141.327 242.498C141.385 239.817 139.281 237.661 136.651 237.661ZM192.292 237.952C194.805 237.952 196.792 239.817 196.792 242.148C196.792 244.479 194.747 246.345 192.292 246.345C189.779 246.345 187.792 244.479 187.792 242.148C187.792 239.875 189.779 237.952 192.292 237.952ZM204.04 221.109C206.845 221.109 209.066 223.323 209.066 226.121C209.066 228.86 206.787 231.133 204.04 231.133C201.234 231.133 199.013 228.918 199.013 226.121C199.013 223.323 201.234 221.109 204.04 221.109ZM122.507 219.652C119.701 219.652 117.48 221.866 117.48 224.664C117.48 227.403 119.76 229.676 122.507 229.676C125.312 229.676 127.533 227.461 127.533 224.664C127.533 221.866 125.312 219.652 122.507 219.652ZM193.695 210.676C195.331 210.676 196.676 212.017 196.676 213.649C196.676 215.28 195.331 216.621 193.695 216.621C192.058 216.621 190.714 215.28 190.714 213.649C190.714 212.017 192.058 210.676 193.695 210.676ZM133.144 208.287C131.508 208.287 130.163 209.627 130.163 211.259C130.163 212.891 131.508 214.231 133.144 214.231C134.781 214.231 136.125 212.891 136.125 211.259C136.125 209.569 134.839 208.287 133.144 208.287ZM202.52 187.13C206.319 187.13 209.358 190.161 209.358 193.949C209.358 197.679 206.319 200.768 202.52 200.768C198.721 200.768 195.682 197.738 195.682 193.949C195.682 190.161 198.721 187.13 202.52 187.13ZM125.079 187.13C121.279 187.13 118.24 190.161 118.24 193.949C118.24 197.679 121.279 200.768 125.079 200.768C128.878 200.768 131.917 197.738 131.917 193.949C131.917 190.161 128.819 187.13 125.079 187.13ZM190.13 177.922C191.766 177.922 193.11 179.262 193.11 180.894C193.11 182.526 191.766 183.867 190.13 183.867C188.493 183.867 187.149 182.526 187.149 180.894C187.149 179.262 188.493 177.922 190.13 177.922ZM137.411 177.922C135.774 177.922 134.43 179.262 134.43 180.894C134.43 182.526 135.774 183.867 137.411 183.867C139.047 183.867 140.392 182.526 140.392 180.894C140.392 179.262 139.047 177.922 137.411 177.922Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.502 156.766H131.51C124.028 181.943 118.242 206.946 118.242 223.964C118.242 253.921 138.64 269.541 163.889 269.541C189.138 269.541 209.711 253.979 209.711 223.964C209.769 207.004 203.925 182.002 196.502 156.766Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.891 156.766H196.501C203.983 181.943 209.769 206.946 209.769 223.964C209.769 237.253 205.736 249.433 199.015 258.875C202.814 250.366 204.976 240.575 204.976 230.142C204.976 213.241 199.482 183.051 190.891 156.766Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 177,
    width: 92,
    height: 71
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 177,
    width: 93,
    height: 71
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.651 237.661C134.079 237.661 131.975 239.817 131.975 242.498C131.975 245.179 134.079 247.335 136.651 247.335C139.223 247.335 141.327 245.179 141.327 242.498C141.385 239.817 139.281 237.661 136.651 237.661ZM192.292 237.952C194.805 237.952 196.792 239.817 196.792 242.148C196.792 244.479 194.747 246.345 192.292 246.345C189.779 246.345 187.792 244.479 187.792 242.148C187.792 239.875 189.779 237.952 192.292 237.952ZM204.04 221.109C206.845 221.109 209.066 223.323 209.066 226.121C209.066 228.86 206.787 231.133 204.04 231.133C201.234 231.133 199.013 228.918 199.013 226.121C199.013 223.323 201.234 221.109 204.04 221.109ZM122.507 219.652C119.701 219.652 117.48 221.866 117.48 224.664C117.48 227.403 119.76 229.676 122.507 229.676C125.312 229.676 127.533 227.461 127.533 224.664C127.533 221.866 125.312 219.652 122.507 219.652ZM193.695 210.676C195.331 210.676 196.676 212.017 196.676 213.649C196.676 215.28 195.331 216.621 193.695 216.621C192.058 216.621 190.714 215.28 190.714 213.649C190.714 212.017 192.058 210.676 193.695 210.676ZM133.144 208.287C131.508 208.287 130.163 209.627 130.163 211.259C130.163 212.891 131.508 214.231 133.144 214.231C134.781 214.231 136.125 212.891 136.125 211.259C136.125 209.569 134.839 208.287 133.144 208.287ZM202.52 187.13C206.319 187.13 209.358 190.161 209.358 193.949C209.358 197.679 206.319 200.768 202.52 200.768C198.721 200.768 195.682 197.738 195.682 193.949C195.682 190.161 198.721 187.13 202.52 187.13ZM125.079 187.13C121.279 187.13 118.24 190.161 118.24 193.949C118.24 197.679 121.279 200.768 125.079 200.768C128.878 200.768 131.917 197.738 131.917 193.949C131.917 190.161 128.819 187.13 125.079 187.13ZM190.13 177.922C191.766 177.922 193.11 179.262 193.11 180.894C193.11 182.526 191.766 183.867 190.13 183.867C188.493 183.867 187.149 182.526 187.149 180.894C187.149 179.262 188.493 177.922 190.13 177.922ZM137.411 177.922C135.774 177.922 134.43 179.262 134.43 180.894C134.43 182.526 135.774 183.867 137.411 183.867C139.047 183.867 140.392 182.526 140.392 180.894C140.392 179.262 139.047 177.922 137.411 177.922Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.502 156.766H131.51C124.028 181.943 118.242 206.946 118.242 223.964C118.242 253.921 138.64 269.541 163.889 269.541C189.138 269.541 209.711 253.979 209.711 223.964C209.769 207.004 203.925 182.002 196.502 156.766Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.12 156.766H131.51C124.028 181.943 118.242 206.946 118.242 223.964C118.242 237.253 122.275 249.433 128.996 258.875C125.197 250.366 123.035 240.575 123.035 230.142C123.093 213.241 128.587 183.051 137.12 156.766Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 156,
    width: 92,
    height: 114
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M196.498 156.766H131.506C124.024 181.943 118.238 206.946 118.238 223.964C118.238 253.921 138.636 269.541 163.885 269.541C189.134 269.541 209.707 253.979 209.707 223.964C209.766 207.004 203.921 182.002 196.498 156.766Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.679 143.244C182.296 162.127 189.193 200.535 189.193 213.532C189.193 232.473 178.614 244.304 164.061 244.304C149.507 244.304 138.461 232.473 138.461 213.532C138.461 200.535 145.299 162.127 149.916 143.244H177.679Z",
    fill: "#EFD36F"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.185 15.7236L137.938 17.6469L144.367 41.9504L151.672 40.0271L145.185 15.7236Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 15,
    width: 15,
    height: 27
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.185 15.7236L137.938 17.6469L144.367 41.9504L151.672 40.0271L145.185 15.7236Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.035 18.3459L140.159 16.1895L146.588 40.5512L138.464 42.6493L132.035 18.3459Z",
    fill: "#CE8710"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.799 5C145.533 5 149.39 8.84659 149.39 13.5674C149.39 18.2882 145.533 22.1348 140.799 22.1348C136.065 22.1348 132.207 18.2882 132.207 13.5674C132.207 8.84659 136.065 5 140.799 5Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 5,
    width: 18,
    height: 18
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.799 5C145.533 5 149.39 8.84659 149.39 13.5674C149.39 18.2882 145.533 22.1348 140.799 22.1348C136.065 22.1348 132.207 18.2882 132.207 13.5674C132.207 8.84659 136.065 5 140.799 5Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.804 7.50578C140.155 7.91375 139.336 9.13766 138.051 10.245C136.765 11.3524 135.42 11.9352 135.07 11.5855C134.719 11.1775 135.537 9.9536 136.823 8.84625C138.167 7.68062 139.512 7.0978 139.804 7.50578Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 5,
    width: 18,
    height: 18
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.799 5C145.533 5 149.39 8.84659 149.39 13.5674C149.39 18.2882 145.533 22.1348 140.799 22.1348C136.065 22.1348 132.207 18.2882 132.207 13.5674C132.207 8.84659 136.065 5 140.799 5Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.164 9.1377C148.924 10.4199 149.391 11.9352 149.391 13.5671C149.391 18.2879 145.534 22.1345 140.8 22.1345C136.942 22.1345 133.669 19.5701 132.559 16.1315C134.078 18.6376 136.825 20.2695 139.923 20.2695C144.657 20.2695 148.514 16.4229 148.514 11.7021C148.573 10.7696 148.456 9.95364 148.164 9.1377Z",
    fill: "#301007"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M182.824 15.7236L190.129 17.6469L183.642 41.9504L176.336 40.0271L182.824 15.7236Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 15,
    width: 15,
    height: 27
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M182.824 15.7236L190.129 17.6469L183.642 41.9504L176.336 40.0271L182.824 15.7236Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.975 18.3459L187.851 16.1895L181.422 40.5512L189.546 42.6493L195.975 18.3459Z",
    fill: "#CE8710"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.209 5C182.475 5 178.617 8.84659 178.617 13.5674C178.617 18.2882 182.475 22.1348 187.209 22.1348C191.943 22.1348 195.8 18.2882 195.8 13.5674C195.859 8.84659 192.001 5 187.209 5Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 5,
    width: 18,
    height: 18
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M187.209 5C182.475 5 178.617 8.84659 178.617 13.5674C178.617 18.2882 182.475 22.1348 187.209 22.1348C191.943 22.1348 195.8 18.2882 195.8 13.5674C195.859 8.84659 192.001 5 187.209 5Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.203 7.50578C187.852 7.91375 188.67 9.13766 189.956 10.245C191.242 11.3524 192.586 11.9352 192.937 11.5855C193.287 11.1775 192.469 9.9536 191.183 8.84625C189.839 7.68062 188.553 7.0978 188.203 7.50578Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 5,
    width: 18,
    height: 18
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M187.209 5C182.475 5 178.617 8.84659 178.617 13.5674C178.617 18.2882 182.475 22.1348 187.209 22.1348C191.943 22.1348 195.8 18.2882 195.8 13.5674C195.859 8.84659 192.001 5 187.209 5Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.845 9.1377C179.085 10.4199 178.617 11.9352 178.617 13.5671C178.617 18.2879 182.475 22.1345 187.209 22.1345C191.066 22.1345 194.339 19.5701 195.45 16.1315C193.93 18.6376 191.183 20.2695 188.086 20.2695C183.351 20.2695 179.494 16.4229 179.494 11.7021C179.435 10.7696 179.611 9.95364 179.845 9.1377Z",
    fill: "#301007"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M188.669 45.0976C188.611 45.6221 189.078 44.1068 189.312 43.6405C189.838 42.6497 190.481 41.7172 191.065 40.7847C192.819 38.162 194.689 35.5394 196.676 33.0915C202.755 25.6898 210.587 19.9199 219.178 15.6653C221.574 14.4997 226.075 11.5856 228.705 13.5672C232.27 16.3064 229.173 26.6223 228.062 30.0026C224.263 41.3675 210.937 53.257 197.67 53.4901L188.669 45.0976Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 12,
    width: 43,
    height: 42
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M188.669 45.0976C188.611 45.6221 189.078 44.1068 189.312 43.6405C189.838 42.6497 190.481 41.7172 191.065 40.7847C192.819 38.162 194.689 35.5394 196.676 33.0915C202.755 25.6898 210.587 19.9199 219.178 15.6653C221.574 14.4997 226.075 11.5856 228.705 13.5672C232.27 16.3064 229.173 26.6223 228.062 30.0026C224.263 41.3675 210.937 53.257 197.67 53.4901L188.669 45.0976Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.129 9.60381C227.187 9.19584 227.655 10.2449 227.888 10.6529C228.297 11.3523 228.531 12.1682 228.765 12.9259C229.349 15.2571 229.7 17.7632 229.291 20.0945C228.005 27.2049 223.68 33.2661 218.771 38.4532C217.134 40.1434 215.439 41.8335 213.627 43.4072C211.582 45.1556 209.478 46.8458 207.081 48.0697C206.614 48.3028 205.27 49.177 204.685 49.0022C203.867 48.7691 202.873 46.904 202.289 46.3212C200.009 44.0482 197.145 42.4164 194.165 41.2507C193.58 41.0176 191.768 40.1434 191.125 40.4348C191.009 40.4931 193.288 42.7661 193.405 42.9409C194.866 44.5145 196.269 46.1464 197.555 47.8948C199.717 50.7506 201.646 53.7813 203.107 57.0451C203.399 57.6862 204.101 60.6002 204.86 60.8916C205.62 61.183 207.783 59.4929 208.309 59.2015C211.932 57.0451 215.322 54.6555 218.478 51.9745C226.953 44.8059 232.622 34.4901 234.084 23.5331C234.843 17.8798 234.025 11.3523 230.051 6.92285L227.129 9.60381Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 12,
    width: 43,
    height: 42
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M188.669 45.0976C188.611 45.6221 189.078 44.1068 189.312 43.6405C189.838 42.6497 190.481 41.7172 191.065 40.7847C192.819 38.162 194.689 35.5394 196.676 33.0915C202.755 25.6898 210.587 19.9199 219.178 15.6653C221.574 14.4997 226.075 11.5856 228.705 13.5672C232.27 16.3064 229.173 26.6223 228.062 30.0026C224.263 41.3675 210.937 53.257 197.67 53.4901L188.669 45.0976Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.597 51.6255C190.48 51.5089 191.824 49.6439 191.941 49.5274C193.519 47.2544 195.273 45.1562 197.085 43.1164C202.053 37.4631 207.897 31.9263 214.502 28.4877C215.378 28.0214 216.314 27.5552 217.307 27.2055C219.236 26.4478 222.45 25.9233 221.749 29.1871C221.632 29.7116 221.457 30.1779 221.281 30.7024C219.879 34.1993 217.424 37.3465 214.852 39.9692C212.456 42.417 209.592 44.3403 206.728 46.0888C202.52 48.6531 198.02 50.1685 193.519 52.0918L190.597 51.6255Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 26,
    width: 32,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 26,
    width: 32,
    height: 27
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.597 51.6255C190.48 51.5089 191.824 49.6439 191.941 49.5274C193.519 47.2544 195.273 45.1562 197.085 43.1164C202.053 37.4631 207.897 31.9263 214.502 28.4877C215.378 28.0214 216.314 27.5552 217.307 27.2055C219.236 26.4478 222.45 25.9233 221.749 29.1871C221.632 29.7116 221.457 30.1779 221.281 30.7024C219.879 34.1993 217.424 37.3465 214.852 39.9692C212.456 42.417 209.592 44.3403 206.728 46.0888C202.52 48.6531 198.02 50.1685 193.519 52.0918L190.597 51.6255Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.669 45.0976C188.611 45.6221 189.078 44.1068 189.312 43.6405C189.838 42.6497 190.481 41.7172 191.065 40.7847C192.819 38.162 194.689 35.5394 196.676 33.0915C202.755 25.6898 210.587 19.9199 219.178 15.6653C221.574 14.4997 226.075 11.5856 228.705 13.5672C232.27 16.3064 229.173 26.6223 228.062 30.0026C224.263 41.3675 210.937 53.257 197.67 53.4901L188.669 45.0976Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.125 9.60478C227.183 9.19681 227.651 10.2459 227.884 10.6539C228.294 11.3532 228.527 12.1692 228.761 12.9268C229.346 15.2581 229.696 17.7642 229.287 20.0955C228.001 27.2058 223.676 33.2671 218.767 38.4542C217.13 40.1444 215.435 41.8345 213.623 43.4081C211.578 45.1566 209.474 46.8467 207.077 48.0707C206.61 48.3038 205.266 49.178 204.681 49.0032C203.863 48.77 202.869 46.905 202.285 46.3222C200.005 44.0492 197.142 42.4173 194.161 41.2517C193.576 41.0186 191.764 40.1444 191.122 40.4358C191.005 40.494 193.284 42.767 193.401 42.9419C194.862 44.5155 196.265 46.1474 197.551 47.8958C199.713 50.7516 201.642 53.7823 203.103 57.046C203.395 57.6871 204.097 60.6012 204.856 60.8926C205.616 61.184 207.779 59.4939 208.305 59.2024C211.929 57.046 215.318 54.6565 218.475 51.9755C226.949 44.8069 232.619 34.491 234.08 23.5341C234.84 17.8808 234.021 11.3532 230.047 6.92383L227.125 9.60478Z",
    fill: "#EEC18F"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.397 45.0976C139.456 45.6221 138.988 44.1068 138.754 43.6405C138.228 42.6497 137.585 41.7172 137.001 40.7847C135.248 38.162 133.377 35.5394 131.39 33.0915C125.312 25.6898 117.48 19.9199 108.888 15.6653C106.492 14.4997 101.991 11.5856 99.3614 13.5672C95.7961 16.3064 98.8938 26.6223 100.004 30.0026C103.803 41.3675 117.129 53.257 130.396 53.4901L139.397 45.0976Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 12,
    width: 43,
    height: 42
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.397 45.0976C139.456 45.6221 138.988 44.1068 138.754 43.6405C138.228 42.6497 137.585 41.7172 137.001 40.7847C135.248 38.162 133.377 35.5394 131.39 33.0915C125.312 25.6898 117.48 19.9199 108.888 15.6653C106.492 14.4997 101.991 11.5856 99.3614 13.5672C95.7961 16.3064 98.8938 26.6223 100.004 30.0026C103.803 41.3675 117.129 53.257 130.396 53.4901L139.397 45.0976Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.883 9.60385C100.824 9.19588 100.357 10.2449 100.123 10.6529C99.7137 11.3523 99.4799 12.1682 99.2461 12.9259C98.6616 15.2572 98.3109 17.7633 98.7201 20.0945C100.006 27.2049 104.331 33.2662 109.24 38.4533C110.877 40.1434 112.572 41.8336 114.384 43.4072C116.429 45.1556 118.533 46.8458 120.93 48.0697C121.397 48.3028 122.742 49.1771 123.326 49.0022C124.144 48.7691 125.138 46.9041 125.722 46.3213C128.002 44.0483 130.866 42.4164 133.846 41.2508C134.431 41.0176 136.184 40.1434 136.886 40.4348C137.003 40.4931 134.723 42.7661 134.606 42.9409C133.145 44.5145 131.742 46.1464 130.457 47.8949C128.294 50.7507 126.365 53.7813 124.904 57.0451C124.612 57.6862 123.911 60.6003 123.151 60.8917C122.391 61.1831 120.228 59.4929 119.702 59.2015C116.079 57.0451 112.689 54.6555 109.533 51.9746C101.058 44.6311 95.3886 34.3735 93.9275 23.3583C93.1677 17.705 93.9859 11.1775 97.9603 6.74805L100.883 9.60385Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 12,
    width: 43,
    height: 42
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.397 45.0976C139.456 45.6221 138.988 44.1068 138.754 43.6405C138.228 42.6497 137.585 41.7172 137.001 40.7847C135.248 38.162 133.377 35.5394 131.39 33.0915C125.312 25.6898 117.48 19.9199 108.888 15.6653C106.492 14.4997 101.991 11.5856 99.3614 13.5672C95.7961 16.3064 98.8938 26.6223 100.004 30.0026C103.803 41.3675 117.129 53.257 130.396 53.4901L139.397 45.0976Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.469 51.6255C137.586 51.5089 136.242 49.6439 136.125 49.5274C134.547 47.2544 132.793 45.1562 130.982 43.1164C126.014 37.4631 120.169 31.9263 113.564 28.4877C112.688 28.0214 111.753 27.5552 110.759 27.2055C108.83 26.4478 105.616 25.9233 106.317 29.1871C106.434 29.7116 106.609 30.1779 106.785 30.7024C108.187 34.1993 110.642 37.3465 113.214 39.9692C115.61 42.417 118.474 44.3403 121.338 46.0888C125.546 48.6531 130.046 50.1685 134.547 52.0918L137.469 51.6255Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 26,
    width: 32,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 26,
    width: 32,
    height: 27
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M137.469 51.6255C137.586 51.5089 136.242 49.6439 136.125 49.5274C134.547 47.2544 132.793 45.1562 130.982 43.1164C126.014 37.4631 120.169 31.9263 113.564 28.4877C112.688 28.0214 111.753 27.5552 110.759 27.2055C108.83 26.4478 105.616 25.9233 106.317 29.1871C106.434 29.7116 106.609 30.1779 106.785 30.7024C108.187 34.1993 110.642 37.3465 113.214 39.9692C115.61 42.417 118.474 44.3403 121.338 46.0888C125.546 48.6531 130.046 50.1685 134.547 52.0918L137.469 51.6255Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.397 45.0976C139.456 45.6221 138.988 44.1068 138.754 43.6405C138.228 42.6497 137.585 41.7172 137.001 40.7847C135.248 38.162 133.377 35.5394 131.39 33.0915C125.312 25.6898 117.48 19.9199 108.888 15.6653C106.492 14.4997 101.991 11.5856 99.3614 13.5672C95.7961 16.3064 98.8938 26.6223 100.004 30.0026C103.803 41.3675 117.129 53.257 130.396 53.4901L139.397 45.0976Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.883 9.60482C100.824 9.19685 100.357 10.2459 100.123 10.6539C99.7137 11.3533 99.4799 12.1692 99.2461 12.9269C98.6616 15.2581 98.3109 17.7643 98.7201 20.0955C100.006 27.2059 104.331 33.2672 109.24 38.4542C110.877 40.1444 112.572 41.8346 114.384 43.4082C116.429 45.1566 118.533 46.8468 120.93 48.0707C121.397 48.3038 122.742 49.1781 123.326 49.0032C124.144 48.7701 125.138 46.9051 125.722 46.3223C128.002 44.0493 130.866 42.4174 133.846 41.2517C134.431 41.0186 136.184 40.1444 136.886 40.4358C137.003 40.4941 134.723 42.7671 134.606 42.9419C133.145 44.5155 131.742 46.1474 130.457 47.8959C128.294 50.7517 126.365 53.7823 124.904 57.0461C124.612 57.6872 123.911 60.6012 123.151 60.8927C122.391 61.1841 120.228 59.4939 119.702 59.2025C116.079 57.0461 112.689 54.6565 109.533 51.9756C101.058 44.6321 95.3886 34.3745 93.9275 23.3593C93.1677 17.706 93.9859 11.1784 97.9603 6.74902L100.883 9.60482Z",
    fill: "#EEC18F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163.77 175.824C141.911 176.115 93.8096 156.591 102.986 107.693C115.961 38.0462 141.677 33.2088 164.004 32.626H164.53C186.74 33.2671 212.164 38.5707 225.081 107.693C234.257 156.824 185.746 176.29 164.004 175.824H163.77Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 32,
    width: 126,
    height: 144
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M163.77 175.824C141.911 176.115 93.8096 156.591 102.986 107.693C115.961 38.0462 141.677 33.2088 164.004 32.626H164.53C186.74 33.2671 212.164 38.5707 225.081 107.693C234.257 156.824 185.746 176.29 164.004 175.824H163.77Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.832 60.6015C131.216 35.5404 148.458 33.0343 164.005 32.6846H164.531C179.961 33.1508 196.969 35.8318 210.178 60.6015C196.735 38.3379 179.902 35.8318 164.531 35.3655H164.005C148.516 35.7735 131.45 38.0465 117.832 60.6015Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 32,
    width: 126,
    height: 144
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163.77 175.824C141.911 176.115 93.8096 156.591 102.986 107.693C115.961 38.0462 141.677 33.2088 164.004 32.626H164.53C186.74 33.2671 212.164 38.5707 225.081 107.693C234.257 156.824 185.746 176.29 164.004 175.824H163.77Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.78 62.583C112.455 72.5492 108.597 85.546 105.5 102.448C105.091 104.546 104.857 106.586 104.682 108.567C103.922 110.607 103.454 112.88 103.454 115.444C103.454 153.386 130.573 169.996 164.005 169.996C197.436 169.996 224.555 153.386 224.555 115.444C224.555 112.938 224.146 110.665 223.328 108.625C223.153 106.644 222.86 104.546 222.51 102.448C219.412 85.546 215.613 72.6074 211.23 62.583C216.607 73.3068 221.341 87.8772 225.023 107.693C225.432 109.849 225.724 111.948 225.9 113.987C226.718 116.086 227.127 118.359 227.127 120.981C227.127 159.797 198.839 176.757 163.946 176.757C129.054 176.757 100.766 159.797 100.766 120.981C100.766 118.417 101.233 116.086 102.051 113.987C102.227 111.948 102.519 109.908 102.928 107.751C106.669 87.8772 111.403 73.3068 116.78 62.583Z",
    fill: "#CE8710"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M164.356 95.2197C184.344 95.2197 227.186 95.686 227.186 120.98C227.186 159.796 198.898 176.756 164.005 176.756C129.112 176.756 100.824 159.796 100.824 120.98C100.824 95.278 144.367 95.2197 164.356 95.2197Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 95,
    width: 128,
    height: 82
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M164.356 95.2197C184.344 95.2197 227.186 95.686 227.186 120.98C227.186 159.796 198.898 176.756 164.005 176.756C129.112 176.756 100.824 159.796 100.824 120.98C100.824 95.278 144.367 95.2197 164.356 95.2197Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.78 62.582C112.455 72.5482 108.597 85.545 105.5 102.447C105.091 104.545 104.857 106.585 104.682 108.566C103.922 110.606 103.454 112.879 103.454 115.443C103.454 153.385 130.573 169.995 164.005 169.995C197.436 169.995 224.555 153.385 224.555 115.443C224.555 112.937 224.146 110.664 223.328 108.625C223.153 106.643 222.86 104.545 222.51 102.447C219.412 85.545 215.613 72.6065 211.23 62.582C216.607 73.3059 221.341 87.8763 225.023 107.692C225.432 109.848 225.724 111.947 225.9 113.986C226.718 116.085 227.127 118.358 227.127 120.98C227.127 159.796 198.839 176.756 163.946 176.756C129.054 176.756 100.766 159.796 100.766 120.98C100.766 118.416 101.233 116.085 102.051 113.986C102.227 111.947 102.519 109.907 102.928 107.75C106.669 87.8763 111.403 73.3059 116.78 62.582Z",
    fill: "#EEC18F"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.423 40.4932C146.819 40.4932 148.748 42.4165 148.748 44.806C148.748 47.1956 146.819 49.1188 144.423 49.1188C142.026 49.1188 140.098 47.1956 140.098 44.806C140.156 42.4165 142.085 40.4932 144.423 40.4932Z",
    fill: "#673620"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.454 49.1191C169.85 49.1191 171.779 51.0424 171.779 53.432C171.779 55.8215 169.85 57.7448 167.454 57.7448C165.058 57.7448 163.129 55.8215 163.129 53.432C163.129 51.0424 165.116 49.1191 167.454 49.1191Z",
    fill: "#673620"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.694 40.4932C186.681 40.4932 188.259 42.0668 188.259 44.0483C188.259 46.0299 186.681 47.6035 184.694 47.6035C182.707 47.6035 181.129 46.0299 181.129 44.0483C181.129 42.0668 182.707 40.4932 184.694 40.4932Z",
    fill: "#673620"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.457 37.1718C160.146 36.8222 162.659 38.8037 163.01 41.6012C163.36 44.3988 161.49 46.9632 158.802 47.3128C156.113 47.6625 153.6 45.681 153.191 42.8834C152.84 40.0859 154.71 37.5215 157.457 37.1718Z",
    fill: "#673620"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.82 56.8125C157.281 56.8125 158.45 57.9781 158.45 59.4352C158.45 60.8922 157.281 62.0578 155.82 62.0578C154.358 62.0578 153.19 60.8922 153.19 59.4352C153.131 58.0364 154.358 56.8125 155.82 56.8125Z",
    fill: "#673620"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.775 50.5763C154.593 50.6928 155.236 51.3922 155.119 52.2664C155.002 53.0824 154.301 53.7235 153.424 53.6069C152.606 53.4904 151.963 52.791 152.08 51.9168C152.197 51.1008 152.898 50.518 153.775 50.5763Z",
    fill: "#673620"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.109 45.0391C175.928 45.0391 176.629 45.7384 176.629 46.5544C176.629 47.3703 175.928 48.0697 175.109 48.0697C174.291 48.0697 173.59 47.3703 173.59 46.5544C173.59 45.7384 174.233 45.0391 175.109 45.0391Z",
    fill: "#673620"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.652 59.1436C173.471 59.1436 174.172 59.8429 174.172 60.6589C174.172 61.4748 173.471 62.1742 172.652 62.1742C171.834 62.1742 171.133 61.4748 171.133 60.6589C171.133 59.8429 171.834 59.1436 172.652 59.1436Z",
    fill: "#673620"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.075 36.9971C172.537 36.9971 173.706 38.1627 173.706 39.6197C173.706 41.0768 172.537 42.2424 171.075 42.2424C169.614 42.2424 168.445 41.0768 168.445 39.6197C168.445 38.1627 169.614 36.9971 171.075 36.9971Z",
    fill: "#673620"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.774 52.8496C146.002 52.8496 146.937 53.8404 146.937 55.006C146.937 56.2299 145.943 57.1625 144.774 57.1625C143.547 57.1625 142.612 56.1717 142.612 55.006C142.553 53.7821 143.547 52.8496 144.774 52.8496Z",
    fill: "#673620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.003 62.8154C165.99 62.8154 167.568 64.389 167.568 66.3706C167.568 68.3522 165.99 69.9258 164.003 69.9258C162.016 69.9258 160.438 68.3522 160.438 66.3706C160.438 64.389 162.016 62.8154 164.003 62.8154Z",
    fill: "#673620"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.369 51.6836C181.771 51.6836 182.882 52.7909 182.882 54.1897C182.882 55.5885 181.771 56.6958 180.369 56.6958C178.966 56.6958 177.855 55.5885 177.855 54.1897C177.855 52.7909 178.966 51.6836 180.369 51.6836Z",
    fill: "#673620"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M141.62 132.462C140.977 132.404 140.334 132.579 139.867 133.045C139.399 133.511 139.165 134.152 139.224 134.794C140.626 146.916 151.205 156.3 164.005 156.3C176.863 156.3 187.442 146.858 188.786 134.794C188.845 134.152 188.611 133.511 188.143 133.045C187.676 132.579 187.033 132.346 186.39 132.462C175.694 133.395 152.14 133.395 141.62 132.462Z",
    fill: "#301007"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 132,
    width: 50,
    height: 25
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M141.62 132.462C140.977 132.404 140.334 132.579 139.867 133.045C139.399 133.511 139.165 134.152 139.224 134.794C140.626 146.916 151.205 156.3 164.005 156.3C176.863 156.3 187.442 146.858 188.786 134.794C188.845 134.152 188.611 133.511 188.143 133.045C187.676 132.579 187.033 132.346 186.39 132.462C175.694 133.395 152.14 133.395 141.62 132.462Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.648 145.459C176.688 145.459 186.449 155.192 186.449 167.198C186.449 179.204 176.688 188.937 164.648 188.937C152.608 188.937 142.848 179.204 142.848 167.198C142.848 155.192 152.608 145.459 164.648 145.459Z",
    fill: "#FF0010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_197_181402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 132,
    width: 50,
    height: 25
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M141.62 132.462C140.977 132.404 140.334 132.579 139.867 133.045C139.399 133.511 139.165 134.152 139.224 134.794C140.626 146.916 151.205 156.3 164.005 156.3C176.863 156.3 187.442 146.858 188.786 134.794C188.845 134.152 188.611 133.511 188.143 133.045C187.676 132.579 187.033 132.346 186.39 132.462C175.694 133.395 152.14 133.395 141.62 132.462Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_197_181402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.247 124.069H146.939C146.705 129.14 146.121 134.269 148.166 138.64C148.459 139.223 148.985 139.631 149.569 139.747C160.323 142.137 167.571 142.195 177.974 139.805C178.617 139.631 179.143 139.223 179.377 138.64C181.715 133.686 181.306 128.907 181.247 124.069Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M164.004 157.814C150.503 157.814 139.223 148.023 137.762 135.026C137.645 133.919 138.054 132.811 138.814 132.054C139.574 131.296 140.684 130.946 141.736 131.063C152.14 131.995 175.401 131.995 186.214 131.063C187.266 130.946 188.318 131.296 189.136 132.054C189.896 132.811 190.305 133.861 190.188 134.968C188.786 148.023 177.506 157.814 164.004 157.814ZM141.386 133.919C141.21 133.919 141.035 133.977 140.918 134.094C140.743 134.268 140.684 134.443 140.684 134.676C141.97 146.216 152.023 154.9 164.004 154.9C175.986 154.9 186.039 146.216 187.325 134.676C187.325 134.502 187.266 134.268 187.091 134.152C186.915 133.977 186.74 133.919 186.506 133.977C175.518 134.91 151.964 134.91 141.444 133.977H141.386C141.444 133.919 141.386 133.919 141.386 133.919Z",
    fill: "#301007"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.687 107.109C127.766 107.109 132.675 109.324 132.675 112.005C132.675 114.686 127.766 116.901 121.687 116.901C115.609 116.901 110.699 114.686 110.699 112.005C110.699 109.266 115.609 107.109 121.687 107.109Z",
    fill: "#E96565"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.32 106.818C212.398 106.818 217.308 109.033 217.308 111.714C217.308 114.395 212.398 116.61 206.32 116.61C200.242 116.61 195.332 114.395 195.332 111.714C195.39 108.975 200.3 106.818 206.32 106.818Z",
    fill: "#E96565"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.392 105.595C150.97 104.953 153.308 106.585 154.652 109.208C155.996 111.831 155.821 114.512 154.301 115.153C152.723 115.794 150.385 114.162 149.041 111.539C147.638 108.917 147.814 106.236 149.392 105.595Z",
    fill: "#301007"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.676 105.595C177.098 104.953 174.76 106.585 173.415 109.208C172.071 111.831 172.247 114.512 173.766 115.153C175.344 115.794 177.682 114.162 179.026 111.539C180.371 108.917 180.195 106.236 178.676 105.595Z",
    fill: "#301007"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.456 61.2422C148.281 61.2422 155.412 68.4691 155.412 77.3862C155.412 86.3033 148.281 93.5302 139.456 93.5302C130.63 93.5302 123.5 86.3033 123.5 77.3862C123.5 68.4691 130.63 61.2422 139.456 61.2422Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.455 66.7207C145.884 66.7207 151.086 71.966 151.086 78.4353C151.086 84.9046 145.884 90.1499 139.455 90.1499C133.026 90.1499 127.824 84.9046 127.824 78.4353C127.824 72.0243 133.026 66.7207 139.455 66.7207Z",
    fill: "#301007"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.854 70.2169C142.731 69.5758 144.484 70.5083 145.828 72.315C147.173 74.1218 147.582 76.1033 146.705 76.7444C145.828 77.3855 144.075 76.453 142.731 74.6463C141.386 72.8396 140.977 70.858 141.854 70.2169Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.996 78.668C147.989 78.668 148.749 79.4839 148.749 80.4164C148.749 81.4072 147.989 82.1649 146.996 82.1649C146.002 82.1649 145.242 81.3489 145.242 80.4164C145.242 79.4839 146.002 78.668 146.996 78.668Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.608 61.2422C197.434 61.2422 204.564 68.4691 204.564 77.3862C204.564 86.3033 197.434 93.5302 188.608 93.5302C179.783 93.5302 172.652 86.3033 172.652 77.3862C172.652 68.4691 179.783 61.2422 188.608 61.2422Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.611 66.7207C195.04 66.7207 200.242 71.966 200.242 78.4353C200.242 84.9046 195.04 90.1499 188.611 90.1499C182.182 90.1499 176.98 84.9046 176.98 78.4353C176.98 72.0243 182.182 66.7207 188.611 66.7207Z",
    fill: "#301007"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.006 70.2169C191.883 69.5758 193.636 70.5083 194.981 72.315C196.325 74.1218 196.734 76.1033 195.857 76.7444C194.981 77.3855 193.227 76.453 191.883 74.6463C190.539 72.8396 190.13 70.858 191.006 70.2169Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.148 78.668C197.142 78.668 197.901 79.4839 197.901 80.4164C197.901 81.4072 197.142 82.1649 196.148 82.1649C195.154 82.1649 194.395 81.3489 194.395 80.4164C194.395 79.4839 195.154 78.668 196.148 78.668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeHappy);
export default __webpack_public_path__ + "static/media/giraffe_happy.e549de0ad8a0b6348671a35ba3098e95.svg";
export { ForwardRef as ReactComponent };